import styled from 'styled-components'
import { Input as FieldInput } from '@components/Field'
import { gold, black, textMuted, mutedGrey, white, grey, border1 } from '@/theme/colors'
import { shadows, radii, motion, layers } from '@/theme/tokens'
import { fontSizes, leading } from '@/theme/typography'
import { flatButton } from '@/theme/recipes'

export const AutocompleteContainer = styled.div`
	position: relative;
	width: 100%;
`

export const Input = styled(FieldInput)`
	padding-right: 40px;
`

export const ClearButton = styled.button`
	${flatButton}
	position: absolute;
	right: 12px;
	top: 50%;
	transform: translateY(-50%);
	width: 24px;
	height: 24px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${mutedGrey};
	font-size: ${fontSizes.headingLg};
	line-height: ${leading.none};
	transition:
		background-color ${motion.fast},
		color ${motion.fast};

	&:hover {
		background-color: ${grey};
		color: ${black};
	}
`

/** Portal-positioned popover list on the overlay shadow. */
export const AutocompleteDropdown = styled.div<{ $top: number; $left: number; $width: number }>`
	position: fixed;
	top: ${({ $top }) => $top}px;
	left: ${({ $left }) => $left}px;
	width: ${({ $width }) => $width}px;
	background: ${white};
	border: 1px solid ${border1};
	border-radius: ${radii.inner};
	box-shadow: ${shadows.overlay};
	max-height: 300px;
	overflow-y: auto;
	z-index: ${layers.popover};
`

export const AutocompleteItem = styled.div`
	padding: 12px 16px;
	cursor: pointer;
	transition: background-color ${motion.fast};

	&:hover {
		background-color: ${gold}1f;
	}

	&:not(:last-child) {
		border-bottom: 1px solid ${border1};
	}
`

export const EmptyAutocompleteItem = styled(AutocompleteItem)`
	cursor: default;
	color: ${mutedGrey};
	font-size: ${fontSizes.small};
`

/**
 * The trailing "use it as typed" row. Sits below the real matches and reads as
 * the quieter fallback it is, on the same density as its siblings.
 */
export const CustomLocationItem = styled(AutocompleteItem)`
	font-size: ${fontSizes.small};
	color: ${textMuted};
`

export const MainText = styled.div`
	font-size: ${fontSizes.small};
	font-weight: 500;
	color: ${black};
	margin-bottom: 2px;
`

export const SecondaryText = styled.div`
	font-size: ${fontSizes.micro};
	color: ${textMuted};
`
